const memoizer = require('../request-handler/utils/memoizer');


function parseResponseData(data) {
  if ((!data) || data.length == 0) {
    return null;
  }
  else {
    return JSON.stringify(data);
  }
}

function serviceFactory({ api }) {

  const get = memoizer()((metaData) =>
    api.get(metaData).then((response) => {
      if (!response) return null;
      if(response && response.userPref && response.userPref.prefLanguage === null){
        response.userPref.prefLanguage = 'English';
        return JSON.stringify(response);
      }
      return JSON.stringify(response);
    }).catch((error) => {
      return null;
    })
  );
  const save = memoizer()((metaData, preferredLang) =>
    api.save(metaData, preferredLang).then((response) => {
      if (!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
      return null;
    })
  );

  const setUserPreferredLanguage = ({ inputparams, metaData }) =>
    api
      .setUserPreferredLanguage(inputparams, metaData)
      .then(parseResponseData)
      .catch(() => null);

  const updateDeviceDetails = memoizer()((deviceCode, deviceModel, deviceOs, metaData) =>
    api.updateDeviceDetails(deviceCode, deviceModel, deviceOs, metaData).then((response) => {
      if (!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
      return null;
    })
  );

  const getPfMapData = ((metaData) =>
  api.getPfMapData(metaData).then((response) => {
    if (!response) return null;
    return JSON.stringify(response);
  }).catch((error) => {
    return null;
  })
);

  const saveFileDownloadConsent = ({inputParam, metaData}) =>
  api.saveFileDownloadConsent(inputParam,metaData)
  .then(parseResponseData) 
  .catch(() => null);

  const getSepaIpLimit = memoizer()((inputs, metaData) =>
    api.getSepaIpLimit(inputs, metaData)
      .then(parseResponseData)
      .catch(() => null)
  );

  const saveSepaIpLimit = memoizer()((inputs, metaData) =>
    api.saveSepaIpLimit(inputs, metaData)
      .then(parseResponseData)
      .catch(() => null)
  );
  
  return {
    get,
    save,
    setUserPreferredLanguage,
    updateDeviceDetails,
    getPfMapData,
    saveFileDownloadConsent,
    getSepaIpLimit,
    saveSepaIpLimit
  };
}

module.exports = serviceFactory;